export const FormEndpoint = "https://formspree.io/f/mrbbevgj";

export const CompanyInfo = Object.freeze({
    address: 'Flamestone SE, Na strži 1702/65, Nusle, 140 00 Prague, Czech Republic',
    companyId: '293 73 301',
    vatId: 'CZ29373301',
    email: 'info@flamestone.eu',
    phone: '+420773550064'
});